import '../../styles/Header.css';
import ucp from '../../assets/logo/ucp.png';
import republique from '../../assets/logo/republique.png';
import msanp from '../../assets/logo/msanp.png';
import React, { useEffect } from 'react';

const Header = () => {

  return (
    <header className="header-fixed">
      <div className="header-limiter">
        <div className="logo-container">
          <img className="logo msanp" src={msanp} alt="MSANP" />
          <img className="logo republique" src={republique} alt="République" />
          <img className="logo ucp" src={ucp} alt="UCP" />
        </div>
      </div>
      <div className="header-fixed-placeholder"></div>
    </header>
  );
};

export default Header;
